import React from "react";
import { useProfile } from "app/context";
import { StoryTrendLink } from "app/links";

import MinimalistAccordion from "components/common/MinimalistAccordion";
import AnswerPrompts from "components/stories/AnswerPrompts";
import StoryTagsLegend from "components/stories/StoryTagsLegend";
import PromptImage from "components/stories/PromptImage";

const Container = ({ children }) => (<div className="trend-item">{children}</div>);
const Thumbnail = ({ storyQuestion }) => <PromptImage className="trend-item__thumbnail" prompt={storyQuestion} />;
const Prompt = ({ prompt }) => (
  <StoryTrendLink storyQuestion={prompt}>{prompt.question}</StoryTrendLink>
);
const Message = ({ message }) => (<span className="message">{message}</span>);
const Details = ({ children }) => (<div className="details">{children}</div>);

const storyTagLegend = ({ id, totalStoriesCount, trendingStoriesCount, points }) => ({
  id,
  answers: trendingStoriesCount || totalStoriesCount,
  isTrending: trendingStoriesCount > 0,
  points
});


const ContentItem = ({ storyQuestion, isProfile }) => (
  <Container>
    <StoryTrendLink storyQuestion={storyQuestion}>
      <Thumbnail storyQuestion={storyQuestion} />
    </StoryTrendLink>
    <Details>
      <Prompt prompt={storyQuestion} />
      <Message message={storyQuestion.summary} />
      <StoryTagsLegend
        isProfile={isProfile}
        story={storyTagLegend(storyQuestion)}
      />
    </Details>
  </Container>
);

const WithChildStoryQuestions = ({ storyQuestion, profile, isProfile }) => (
  <MinimalistAccordion
    upDown
    coverRenderer={<ContentItem storyQuestion={storyQuestion} isProfile={isProfile} />}
  >
    <AnswerPrompts
      childStoryQuestions={storyQuestion.childStoryQuestions}
      onPosted={() => {}}
      parentId={storyQuestion.id}
      profile={profile}
      noOptions
    />
  </MinimalistAccordion>
);

const TrendItem = ({ storyQuestion, isProfile }) => {
  const { profile } = useProfile();

  return (
    !storyQuestion.childStoryQuestions?.length
      ? <ContentItem storyQuestion={storyQuestion} isProfile={isProfile} />
      : (
        <WithChildStoryQuestions
          storyQuestion={storyQuestion}
          profile={profile}
          isProfile={isProfile}
        />
      )
  );
};

export default TrendItem;
